export enum ForecastMethod {
    FLAT_BVI = 'FlatBVI',
    FLAT_FTE = 'FlatFTE',
    FLAT_PACKAGE = 'FlatPackage',
    TRX_FTE = 'TrxFTE',
    TRX_BVI = 'TrxBVI',
    AVG_TRX_BVI = 'AvgTrxBVI',
    MANUAL = 'Manual'
}
